import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { OcrCardRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { OcrCardResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const ocrCard = (request: OcrCardRequest, options?: CashRequestOptions) =>
  post<OcrCardRequest, OcrCardResponse>('/2.0/cash/ocr-card', request, { ...options, rejectOnError: true })
